<template>
<div class="row plain-element">
    <div v-if="!isLoggedIn()"  class="dashboard-cards">
        <NoPermissionComponent/>
    </div>
   <div v-if="getUsername() && getCorporatePlanData()" class="dashboard">
    <div class="row row-cards">
      <div class="row text-start row-back">
        <a class="back-link" @click="hasHistory() ? $router.go(-1): $router.push('/')">
          <span class="material-icons chevron-left">chevron_left</span> Back To Corporate Plan
        </a>
      </div>
    </div>
    <div class="card card-details card-opportunity-select">
      <p class="error"  v-if="getFormError()">
        <span id="formError">{{ getFormError() }}</span>
      </p>
      <p class="error"  v-else>
      </p>
           <AttachRemoveCorporateSitePlanComponent
              :id = id
              :name = getCorporatePlanData().name
              :company = getCorporatePlanData().company
              :sitePlansArray = getCorporatePlanData().corporate_site_plan_relation_list
           />
      </div>

    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import { hasHistory } from "@/common/general.js";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"
import AttachRemoveCorporateSitePlanComponent from "@/components/corporate_plans/AttachRemoveCorporateSitePlanComponent.vue";

export default {
  name: "AttachRemoveCorporateSitePlan",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    NoPermissionComponent,
    AttachRemoveCorporateSitePlanComponent,
  },
  data() {
    return {

    }
  },
  methods: {
    ...mapGetters(["getCorporatePlanData", "getUsername", "isLoggedIn","getFormError"]),
    ...mapActions(["fetchCorporatePlanData", "performSetFormError"]),
    hasHistory: hasHistory,
    getCorporatePlanDetails(id) {
      this.fetchCorporatePlanData({"id": id })
    },


  },
  computed: {

  },
  created() {
    this.getCorporatePlanDetails(this.id);
    this.performSetFormError(null);
    document.title = "Attach/Remove Site Plans";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.chosenId = to.params.id;
    this.getCorporatePlanDetails(this.chosenId);
    next();
  }

}
</script>
